import {
    getField,
    updateField
} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState() {
    return {};
}

const state = initialState();

const getters = {
    getField,
};

const actions = {
    async impersonate(context, payload) {

        var impersonate_session = await API.impersonation.create(payload);
        await context.dispatch('beforeImpersonation');
        await context.dispatch('takeImpersonation', impersonate_session);
        router.push({
            name: "Companies"
        })
    },

    async beforeImpersonation(context) {
        // backup the session data before impersonation
        var previous_session = context.rootGetters['auth/getSession'];
        var previous_profile = context.rootGetters['user/getUser'];

        await context.dispatch('resetAll', {}, DEFINES.USE_ROOT);

        context.commit('auth/set_previous_session', previous_session, DEFINES.USE_ROOT);
        context.commit('user/set_previous_profile', previous_profile, DEFINES.USE_ROOT);

    },

    async takeImpersonation(context, payload) {

        await context.dispatch('setSession', payload);
        context.commit('user/set_profile', {
            user: payload.user
        }, DEFINES.USE_ROOT);
    },


    async leave(context, payload) {
        await API.impersonation.leave(payload);
        await context.dispatch('afterLeave');
    },

    async afterLeave(context, payload) {

        //after leave impersonation again set previous session to current
        var previous_session = context.rootGetters['auth/getPreviousSession'];
        var previous_profile = context.rootGetters['user/getPreviousProfile'];
        context.dispatch('resetAll', {}, DEFINES.USE_ROOT);

        context.dispatch('setSession', previous_session);

        context.commit('user/set_profile', {
            user: previous_profile
        }, DEFINES.USE_ROOT);

        router.push({
            name: 'AdminUserList'
        });
    },
    async setSession(context, payload) {

        context.commit('auth/set_key', {
            key: payload.key
        }, DEFINES.USE_ROOT);

        context.commit('auth/set_secret', {
            secret: payload.secret
        }, DEFINES.USE_ROOT);

        context.commit('auth/set_session_mode', {
            session_mode: payload.session_mode
        }, DEFINES.USE_ROOT);

    }
};

const mutations = {
    updateField,
    reset(state) {
        // acquire initial state
        const s = initialState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
